import React, { Component } from 'react';
import styles from './Notification.module.css';
import axios from 'axios';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import loader from '../../assets/loader2.svg';

class Notification extends Component {
  
    state = {
        notifications: [],
        acceptClicked:[],
        modal: {
            isModalOpen: false,
            userId: '',
            name: '',
            profilePic: '',
            clicked: false
        },
        isLoading: true
    }
    acceptQueue = [];
    rejectQueue = [];
    modalRef = React.createRef();
    acceptRef = React.createRef();
    rejectRef = React.createRef();

    componentDidMount() {
        document.addEventListener('click', this.checkClickOutside);
        axios.get('/users/'+ this.props.loginStatus.userId 
        + '/notifications.json?auth='+ this.props.loginStatus.authToken)
        .then(response=>{    
            let shouldPost = false;
            const notifications = [...response.data];
            notifications.map(data=>{
                if(!data.isRead) {
                    data.isRead = true;
                    shouldPost = true;
                }
            });
            if(shouldPost) {
             axios.put('/users/'+ this.props.loginStatus.userId 
             + '/notifications.json?auth='+ this.props.loginStatus.authToken, notifications);

            }        
           this.setState({
                notifications: [...notifications].reverse(),
                isLoading: false
            });
           
        })
        .catch(error=>console.log(error))
    }

    checkClickOutside = (event) => {
       if(!this.modalRef.current.contains(event.target)) this.props.close()
    }
    componentWillUnmount() {
        document.removeEventListener('click',  this.checkClickOutside);
    }
    
    getNotificationMessage = (key) => {
        switch (key) {
            case 'GREET':
               return 'welcomes you to FakeInsta';
            case 'FOLLOW':
                return 'started following you';
            case 'ACCEPTED' :
                return 'accepted your follow request'
            case 'LIKE':
                return 'liked your photo';
            case 'COMMENT':
                return 'commented on your photo';
            case 'REQUEST':
                return ''
            case 'REMOVE':
                return 'Your post has been removed'
            default:
                return;
        }
    }

    accept = (userId) => {
        const accElem = document.getElementById('acc'+userId);
        accElem.disabled = true;
        accElem.nextElementSibling.disabled = true;
        const loggedInUserId = this.props.loginStatus.userId;
        let isFirst = this.acceptQueue.length === 0;
        if(this.acceptQueue.indexOf(userId) === -1){
            this.acceptQueue.push(userId);
        } else {
            isFirst = true;
        }
        if(!isFirst) return;
        axios.get('/users/' + userId + '.json?auth=' + 
        this.props.loginStatus.authToken)
         .then(response => {
             const userData = response.data;
             if(userData.following.indexOf(loggedInUserId) !== -1) return;
             userData.following.push(loggedInUserId);
             
            const sentReqIndex = userData.sentRequest.indexOf(loggedInUserId);
            if(sentReqIndex !== -1) userData.sentRequest.splice(sentReqIndex, 1);
           
            axios.put('/users/' + userId + '.json?auth=' + 
            this.props.loginStatus.authToken, userData)
            .catch(err=>console.log(err));

            axios.get('/users/'+ loggedInUserId +'.json?auth='+ 
            this.props.loginStatus.authToken)
            .then(response2 => {
                const loggedInUserData = response2.data;
                loggedInUserData.followers.push(userId);
                const reqIndex = loggedInUserData.requests.indexOf(userId);
                if(reqIndex !== -1) loggedInUserData.requests.splice(reqIndex, 1);
                loggedInUserData.notifications.map((obj, index) => {
                    if(obj.userId === userId && obj.key === 'REQUEST') {
                        loggedInUserData.notifications.splice(index, 1);
                    }
                })
                axios.put('/users/'+ loggedInUserId +'.json?auth='+ 
                this.props.loginStatus.authToken, loggedInUserData)
                .then((res) => {
                    this.acceptQueue.shift();
                    this.setState({
                        notifications: res.data.notifications
                    });
               if(this.acceptQueue.length > 0) this.accept(this.acceptQueue[0]);
              
           })
           .catch(error=>console.log(error));
       })
         })
         .catch(err=>console.log(err));
    }

    reject = (userId) => {
        const rejElem = document.getElementById('rej'+userId);
        rejElem.disabled = true;
        rejElem.previousElementSibling.disabled = true;
        const loggedInUserId = this.props.loginStatus.userId;
        let isFirst = this.rejectQueue.length === 0;
        if(this.rejectQueue.indexOf(userId) === -1){
            this.rejectQueue.push(userId);
        } else {
            isFirst = true;
        }
        if(!isFirst) return;
        axios.get('/users/' + userId + '/sentRequest.json?auth=' + 
        this.props.loginStatus.authToken)
         .then(response => {
             const sentRequests = response.data;             
            const sentReqIndex = sentRequests.indexOf(loggedInUserId);
            if(sentReqIndex !== -1) sentRequests.splice(sentReqIndex, 1);
           
            axios.put('/users/' + userId + '/sentRequest.json?auth=' + 
            this.props.loginStatus.authToken, sentRequests)
            .catch(err=>console.log(err));

            axios.get('/users/'+ loggedInUserId +'.json?auth='+ 
            this.props.loginStatus.authToken)
            .then(response2 => {
                const loggedInUserData = response2.data;
                const reqIndex = loggedInUserData.requests.indexOf(userId);
                if(reqIndex !== -1) loggedInUserData.requests.splice(reqIndex, 1);
                loggedInUserData.notifications.map((obj, index) => {
                    if(obj.userId === userId && obj.key === 'REQUEST') {
                        loggedInUserData.notifications.splice(index, 1);
                    }
                })
                axios.put('/users/'+ loggedInUserId +'.json?auth='+ 
                this.props.loginStatus.authToken, loggedInUserData)
                .then((res) => {
                    this.rejectQueue.shift();
                    this.setState({
                        notifications: res.data.notifications
                    });
               if(this.rejectQueue.length > 0) this.reject(this.rejectQueue[0]);
              
           })
           .catch(error=>console.log(error));
       })
         })
         .catch(err=>console.log(err));
    }

    render() {
        return (
                <div className={styles.modal} ref={this.modalRef}>
                    <div className={styles.header}>
                            Notifications
                    </div>
                    <div className={styles.body}>
                    {this.state.isLoading ?
                        <div style={{margin:'auto',marginTop:'25%'}}>
                             <img src={loader} alt="loading" width="30" height="30"/>
                        </div> : null
                    }
                    
                    {this.state.notifications.map((data, index) => {
                    return (
                       <div className={[styles.user, !data.isRead ? styles.unread : ''].join(' ')} key={index}>
                        <div className={styles.dp}>
                            <Link to={'/account/' + data.userId} onClick={this.props.close}>
                            <img src={data.profilePic} 
                            width="35" height="35" alt={'profile pic'} /> 
                            </Link>
                        </div>
                        <div className={[styles.details, data.key==='REQUEST'?styles.reqDetails:'',
                            data.name.length>15?styles.blockDetails:''].join(' ')}>
                        <span style={{width:data.key !== 'REQUEST'?'320%':'',textAlign:'left'}}>
                        <Link to={'/account/' + data.userId} onClick={this.props.close}>
                            <h2 className={styles.name}>{data.name}</h2> 
                        </Link>
                          {this.getNotificationMessage(data.key)}
                          </span>
                        
                          {data.key === 'REQUEST' ?
                           <div id={styles.reqDiv}>
                           <button className={styles.accept} id={'acc'+data.userId} onClick={()=>this.accept(data.userId)}>Accept</button>
                           <button className={styles.reject} id={'rej'+data.userId} onClick={()=>this.reject(data.userId)}>Reject</button>
                           </div>
                            :null
                          }
                          
                          {data.key === 'LIKE' || data.key === 'COMMENT' || data.key === 'REMOVE' ?
                            <span style={{lineHeight:0}}><img src={data.url} alt="post" className={styles.post} /></span> :null
                          }
                        </div>
                       
                     </div>
                    )}) }
                    </div>
            </div>
        ) 
     }
    }

const mapStateToProps = state => {
    return {
        loginStatus: state.loginStatus
    }
}
export default connect(mapStateToProps)(Notification);